/**
 * O símbolo do Clinuma.
 *
 * O arco é um C que não fecha — a clínica que recebe. A linha que sobe
 * dentro dele é o gráfico de evolução do paciente, que o banco já
 * projeta desde a semana 7.
 *
 * A espessura do traço CRESCE quando o tamanho encolhe: em 16px um
 * traço de 7 unidades desaparece. Marca que só funciona grande some na
 * aba do navegador, que é onde a recepção procura o sistema entre
 * quinze abas abertas.
 */
export function Marca({ tamanho = 28, comNome = true }: {
  tamanho?: number
  comNome?: boolean
}) {
  const traco = tamanho <= 18 ? 10 : tamanho <= 24 ? 9 : 7
  return (
    <span className="marca" style={{ display: 'inline-flex', alignItems: 'center', gap: 9 }}>
      <svg width={tamanho} height={tamanho} viewBox="0 0 64 64" fill="none"
           role="img" aria-label="Clinuma">
        <path d="M52 17.5A26 26 0 1 0 52 46.5" stroke="var(--cl-marca)"
              strokeWidth={traco} strokeLinecap="round" />
        <path d="M25 38.5 L33 34 L41 26.5" stroke="var(--cl-acento)"
              strokeWidth={traco - 1} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {comNome && (
        <span style={{
          fontFamily: 'var(--cl-fonte-titulo)',
          fontWeight: 660,
          fontSize: tamanho * 0.66,
          letterSpacing: '-0.03em',
        }}>Clinuma</span>
      )}
    </span>
  )
}
